'use client';

import React, { useState, useEffect } from 'react';

// 创建一个简单的Context来管理应用的语言
export const LanguageContext = React.createContext({
  language: 'en',
  setLanguage: (lang: string) => {},
});

// 提供LanguageProvider供全局使用
export const LanguageProvider: React.FC<{children: React.ReactNode}> = ({ children }) => {
  // 从localStorage获取初始语言，如果没有则默认为英文
  const [language, setLanguage] = useState('en');
  const [mounted, setMounted] = useState(false);
  
  // 组件挂载后执行的操作
  useEffect(() => {
    // 标记组件已挂载
    setMounted(true);
    
    // 读取localStorage中保存的语言设置
    try {
      const savedLanguage = localStorage.getItem('language');
      if (savedLanguage) {
        setLanguage(savedLanguage);
      }
    } catch (error) {
      console.error('Failed to access localStorage:', error);
    }
  }, []);
  
  // 当语言改变且组件已挂载后，保存到localStorage
  useEffect(() => {
    if (!mounted) return;
    
    try {
      localStorage.setItem('language', language);
      document.documentElement.lang = language;
    } catch (error) {
      console.error('Failed to save language to localStorage:', error);
    }
  }, [language, mounted]);
  
  // 返回上下文提供者
  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

// 语言切换按钮组件
const LanguageToggle = () => {
  const { language, setLanguage } = React.useContext(LanguageContext);
  const [mounted, setMounted] = useState(false);

  // 等待组件挂载后再显示UI，避免SSR水合错误
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'zh' : 'en');
  };

  return (
    <button
      onClick={toggleLanguage}
      className="p-2 rounded-md bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors duration-200"
      aria-label="Toggle language"
    >
      <span className="text-sm font-medium">
        {language === 'en' ? '中文' : 'EN'}
      </span>
    </button>
  );
};

export default LanguageToggle; 